import { useSyncExternalStore } from 'react'

export type OnboardingViewFocus = {
  registrationId: string
  /** Business / tenant name from the registration record. */
  businessName?: string
  propertyName?: string
  utilityName?: string
}

let currentFocus: OnboardingViewFocus | null = null
const listeners = new Set<() => void>()

function emit(): void {
  listeners.forEach((listener) => listener())
}

/** Called from OnboardingDetail when the registration loads. Cleared on unmount. */
export function setOnboardingViewFocus(focus: OnboardingViewFocus | null): void {
  currentFocus = focus
  emit()
}

export function getOnboardingViewFocus(): OnboardingViewFocus | null {
  return currentFocus
}

export function subscribeOnboardingViewFocus(listener: () => void): () => void {
  listeners.add(listener)
  return () => {
    listeners.delete(listener)
  }
}

export function useOnboardingViewFocus(): OnboardingViewFocus | null {
  return useSyncExternalStore(subscribeOnboardingViewFocus, getOnboardingViewFocus, () => null)
}
